import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";

export default styled(Accordion)(({ theme, ownerState }) => {
  const { palette, functions, borders } = theme;
  const { color, darkMode } = ownerState;

  const { white, black, text, transparent } = palette;
  const { pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    backgroundColor: transparent.main,
    color: darkMode ? white.main : black.main,
    margin: `${pxToRem(16)} ${pxToRem(24)}`, // Adiciona margem horizontal
    width: "auto", // Garante que o Accordion não ocupe toda a largura

    "& .MuiAccordionSummary-root": {
      backgroundColor: color === "transparent" ? transparent.main : palette[color].main,
      color: color === "white" ? black.main : white.main,
      borderRadius: `${borderRadius.md} ${borderRadius.md} 0 0`,
      padding: `${pxToRem(12)} ${pxToRem(24)}`, // Adiciona padding horizontal

      "& .MuiAccordionSummary-expandIconWrapper": {
        color: color === "white" ? black.main : white.main,
      },

      "& .MuiAccordionSummary-content": {
        margin: `${pxToRem(8)} 0`, // Ajusta o espaçamento vertical do conteúdo
      },
    },

    "& .MuiAccordionDetails-root": {
      backgroundColor: darkMode ? palette.background.default : white.main,
      borderRadius: `0 0 ${borderRadius.md} ${borderRadius.md}`,
      padding: pxToRem(24), // Aumenta o padding interno dos detalhes
    },
  };
});
